import { render, staticRenderFns } from "./ActivityMonitor.vue?vue&type=template&id=5dedf59c&scoped=true"
import script from "./ActivityMonitor.vue?vue&type=script&lang=ts"
export * from "./ActivityMonitor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedf59c",
  null
  
)

export default component.exports